<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.keywords" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getUsers">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addUser">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changePwd" v-show="this.sels.length===1">修改密码</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="enabledUser" v-show="this.sels.length>0">启用</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="disabledUser" v-show="this.sels.length>0">禁用</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="users" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;" @sort-change="sortchange" :height="bodyHeight-220">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column prop="userCode" label="用户编号" min-width="150" sortable="custom">
      </el-table-column>
      <el-table-column prop="userName" label="用户名称" min-width="200" sortable="custom">
      </el-table-column>
      <el-table-column prop="status" label="状态" min-width="100" :formatter="formatStatus" sortable="custom">
      </el-table-column>
      <el-table-column prop="createDate" label="创建日期" min-width="120" sortable="custom" :formatter="formatdate">
      </el-table-column>
      <el-table-column label="操作" width="250">
        <template scope="scope">
          <el-button size="small" @click="editUser(scope.$index, scope.row)">编辑</el-button>
          <el-button type="success" size="small" @click="authorize(scope.$index, scope.row)">授权</el-button>
          <el-button type="danger" size="small" @click="delUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="prev, pager, next" @current-change="pageChange" :page-size="pagesize" :total="records" style="float:right;">
    </el-pagination>

    <!--新增界面-->
    <el-dialog :title="userTitle" :visible.sync="addFormVisible" :close-on-click-modal="false" size="tiny">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-form-item label="用户编号" prop="userCode">
          <el-input v-model="addForm.userCode" :disabled="isEditModel"></el-input>
        </el-form-item>
        <el-form-item label="用户名称" prop="userName">
          <el-input v-model="addForm.userName"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password2">
          <el-input v-model="addForm.password2" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="saveUser" :loading="addLoading">保存</el-button>
        <el-button @click.native="addFormVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!--修改密码-->
    <el-dialog title="修改密码" :visible.sync="changePwdVisible" :close-on-click-modal="false" size="tiny">
      <el-form :model="changePwdForm" label-width="80px" :rules="changePwdFormRules" ref="changePwdForm">
        <el-form-item label="密码" prop="password">
          <el-input v-model="changePwdForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password2">
          <el-input v-model="changePwdForm.password2" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="handleChangePwd" :loading="changePwdLoading">确认</el-button>
        <el-button @click.native="changePwdVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!--授权-->
    <el-dialog title="用户授权" :visible.sync="userPermissionVisible" :close-on-click-modal="false">
      <el-form :model="userPermissionForm" ref="userPermissionForm">
        <div v-for="g in userPermissionForm.PermissionResourcesGroups" style="margin-top:15px">
          <div style="font-size: Medium"><i class="el-icon-caret-right">{{g.type}}</i></div>
          <div style="padding: 5px 0px 5px 0px; border-bottom: dashed 2px #eee; ">
            <el-checkbox-group v-model="g.userPermissions">
              <el-checkbox v-for="p in g.data" :label="p.prCode" :key="p.prCode">{{p.caption}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="handleUserPermission()" :loading="userPermissionLoading">确认</el-button>
        <el-button @click.native="userPermissionVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: 'usermanage',
  props: ['bodyHeight'],
  data() {
    return {
      filters: {
        keywords: ''
      },
      sels: [],
      listLoading: false,
      sortname: 'userCode',
      sorttype: 'ascending',
      pagesize: 20,
      pageno: 1,
      records: 0,
      totalpages: 0,
      users: [
      ],
      userTitle: '新增',
      isEditModel: false,
      addFormVisible: false, // 新增界面是否显示
      addLoading: false,
      addFormRules: {
        userCode: [
          { required: !this.isEditModel, message: '请输入用户编号', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        password2: [
          {
            validator: (rule, value, callback) => {
              if (value === this.addForm.password) {
                callback()
              } else {
                callback(new Error('两次密码输入不一致'))
              }
            },
            trigger: 'blur'
          }
        ]
      },
      // 新增界面数据
      addForm: {
        userId: 0,
        userCode: '',
        userName: '',
        password: '',
        password2: ''
      },
      changePwdVisible: false, // 修改密码是否显示
      changePwdLoading: false,
      changePwdFormRules: {
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        password2: [
          {
            validator: (rule, value, callback) => {
              if (value === this.changePwdForm.password) {
                callback()
              } else {
                callback(new Error('两次密码输入不一致'))
              }
            },
            trigger: 'blur'
          }
        ]
      },
      // 修改密码界面数据
      changePwdForm: {
        password: '',
        password2: ''
      },
      userPermissionVisible: false,
      userPermissionLoading: false,
      // 用户授权
      userPermissionForm: {
        userId: 0,
        // UserPermissions: [],
        PermissionResources: [],
        PermissionResourcesGroups: {}
      }
    }
  },
    methods: {     
    formatdate: function(row, col, value) {
      return new Date(value).Format('yyyy-MM-dd hh:mm:ss')
    },
    // 性别显示转换
    formatStatus: function(row) {
      if (row.status === 0) {
        return '正常'
      } else if (row.status === 1) {
        return '禁用'
      } else if (row.status === -2) {
        return '删除'
      } else {
        return '未知'
      }
    },
    // 获取用户列表
    getUsers: function() {
      let para = {
        keywords: this.filters.keywords,
        pageno: this.pageno,
        pagesize: this.pagesize,
        sortname: this.sortname,
        sorttype: (this.sorttype === 'ascending' ? 'asc' : 'desc')
      }

      this.$ajax({
        url: 'api/Account/GetUsers',
        method: 'get',
        data: para,
        loadingName: 'listLoading',
        success: (d, r) => {
          let { records, totalpages } = r
          this.users = d
          this.records = records
          this.totalpages = totalpages
        }
      })
    },
    pageChange: function(val) {
      this.pageno = val
      this.getUsers()
    },
    sortchange: function(sort) {
      this.sortname = sort.prop
      this.sorttype = sort.order
      this.getUsers()
    },
    addUser: function() {
      this.userTitle = '用户新增'
      this.isEditModel = false
      this.addFormVisible = true
      this.addForm = {
        userId: 0,
        userCode: '',
        userName: '',
        password: '',
        password2: ''
      }
      this.$refs.addForm.resetFields()
    },
    saveUser: function() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.addForm)
          this.$ajax({
            url: 'api/Account/SaveUser',
            data: JSON.stringify(para),
            loadingName: 'addLoading',
            success: (response) => {
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 1000
              })
              this.$refs['addForm'].resetFields()
              this.addFormVisible = false
              this.getUsers()
            }
          })
        }
      })
    },
    editUser: function(index, row) {
      this.userTitle = '用户编辑'
      this.isEditModel = true
      this.addForm = Object.assign({ password: '******', password2: '******' }, row)
      this.addFormVisible = true
      this.$refs.addForm.resetFields()
    },
    delUser: function(index, row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        let para = [row.userId]
        this.$ajax({
          url: 'api/Account/DeleteUsers',
          data: JSON.stringify(para)
        }).then((res) => {
          this.listLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getUsers()
        })
      }).catch(() => {
      })
    },
    authorize: async function (index, row) {
      this.userPermissionForm.userId = row.userId
      await this.getPermissionResource()
      await this.getUserPermission(row.userId)
      this.userPermissionVisible = true
    },
    selsChange: function(sels) {
      this.sels = sels
    },
    changePwd: function() {
      this.changePwdVisible = true
      this.changePwdForm = {
        password: '',
        password2: ''
      }
      this.$refs.changePwdForm.resetFields()
    },
    handleChangePwd: function() {
      if (this.sels.length !== 1) {
        this.$message({
          message: '不允许对多个用户执行该操作',
          type: 'error'
        })
        return
      }
      let para = { userId: this.sels[0].userId, newPwd: this.changePwdForm.password }
      this.$ajax({
        url: 'api/Account/ChangeUserPwd',
        loadingName: 'changePwdLoading',
        data: para
      })
      this.changePwdVisible = false
      this.$message({
        message: '修改密码成功',
        type: 'success'
      })
    },
    enabledUser: function() {
      this.$confirm('确认启用选中的用户吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let para = this.sels.map(u => u.userId)
        this.$ajax({
          url: 'api/Account/EnabledUsers',
          data: JSON.stringify(para),
          loadingName: 'listLoading'
        }).then((res) => {
          this.$message({
            message: '启用成功',
            type: 'success'
          })
          this.getUsers()
        })
      }).catch(() => {
      })
    },
    disabledUser: function(index, row) {
      this.$confirm('确认禁用选中的用户吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let para = this.sels.map(u => u.userId)
        this.$ajax({
          url: 'api/Account/DisabledUsers',
          data: JSON.stringify(para),
          loadingName: 'listLoading'
        }).then((res) => {
          this.$message({
            message: '禁用成功',
            type: 'success'
          })
          this.getUsers()
        })
      }).catch(() => {
      })
    },
    // 获取用户权限
    getUserPermission: function(userId) {
      let para = {
        userId: userId
      }

      this.$ajax({
        url: 'api/Account/GetUserPermissionInfo',
        method: 'get',
        data: para,
        loadingName: 'userPermissionLoading',
        success: (d, r) => {          
          d.forEach((item) => {
            let a = this.userPermissionForm.PermissionResources.find(value => value.prCode == item )
            if (a) {
              this.userPermissionForm.PermissionResourcesGroups[a.resource].userPermissions.push(item)
            }
          })         

        }
      })
    },
    // 获取权限资源
    getPermissionResource: function() {
      this.$ajax({
        url: 'api/Account/GetPermissionResourceList',
        method: 'get',
        loadingName: 'userPermissionLoading',
        success: (d, r) => {
          var dd = this.ItemGroupBy(d, "resource")
          Object.keys(dd).forEach(item => { dd[item].userPermissions = [] })
          this.userPermissionForm.PermissionResources = d
          this.userPermissionForm.PermissionResourcesGroups = dd
        }
      })
    },
    ItemGroupBy(arr, key) {
        let newArr = [],
            types = {},
            newItem, i, j, cur;
        for (i = 0, j = arr.length; i < j; i++) {
            cur = arr[i];
            if (!(cur[key] in types)) {
                types[cur[key]] = { type: cur[key], data: [] };
                //newArr.push(types[cur[key]]);
            }
            types[cur[key]].data.push(cur);
        }
        return types;
    },
    handleUserPermission: function () {
      let para = []
      let g = this.userPermissionForm.PermissionResourcesGroups
      Object.keys(g).forEach(item => { para.push(...g[item].userPermissions) });
      this.$ajax({
        url: 'api/Account/UserAuthorize?userId=' + this.userPermissionForm.userId,
        method: 'post',
        loadingName: 'userPermissionLoading',
        data: JSON.stringify(para)
      })
      this.userPermissionVisible = false
    }
  },
  mounted() {
    this.getUsers()
  }
}
</script>